type Props = { onClick?: () => void; };

const FundsButtonLink: FC<Props> = ({ onClick, children }) => (
  <div className="grid gap-4" onClick={onClick}>
    {children}
  </div>
);

export default FundsButtonLink;
